<template>
  <div>
    <table v-if="feeds.length" class="table table-striped">
      <thead>
        <tr>
          <th scope="col">
            Name
          </th>
          <th scope="col">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="feed in feeds" :key="feed.uuid">
          <td>{{ feed.name }}</td>
          <td>
            <a :href="`/feeds/${feed.uuid}/edit`" target="_blank" class="btn btn-sm btn-ss"><i class="flaticon-eye" /> View </a>
            <a href="javascript:;" class="btn btn-sm btn-ss-standout" @click="detachFromFeed(feed)"><i class="flaticon2-cancel" /> Detach </a>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <strong>Not used in any {{ getFeedLabel(true) }}.</strong>
    </div>
    <div>
      <div class="text-md-right">
        <button class="btn btn-ss" @click="assignToFeed">
          <i class="la la-link" /> Assign to {{ getFeedLabel(true) }}
        </button>
      </div>
    </div>
    <assign-to-feed-modal />
  </div>
</template>

<script>
import AssignToFeedModal from 'VueModals/AssignToFeedModal';

export default {
  components: { AssignToFeedModal },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    feeds: [],
  }),
  mounted() {
    this.getItemFeeds();
    EventBus.$on("item-feeds-updated", () => {
      this.getItemFeeds();
    });
  },
  methods: {
    async assignToFeed() {
      const modal_result = await this.fireModal(`assign-to-feed-modal`);
      if (modal_result.data.confirm) {
        const feed = modal_result.data.feed;
        try {
          const res = (await axios.post(`/api/v1/feeds/${feed.uuid}/attachItems`, {
            item_uuids: [this.item.uuid],
          })).data;
          if (res.success) {
            EventBus.$emit('item-feeds-updated');
            toastr.success(`Successfully assigned to feed ${feed.name}!`);
          } else {
            toastr.error(`Unable to assign to feed ${feed.name}.`);
          }
        } catch (err) {
          toastr.error(err);
          console.error(err);
        }
      }
    },
    detachFromFeed(feed) {
      axios.post(`/api/v1/feeds/${feed.uuid}/detachItems`, {
        item_uuids: [this.item.uuid],
      }).then(() => {
        toastr.success(`Detached from ${feed.name}`);
        this.getItemFeeds();
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    async getItemFeeds() {
      try {
        const response = await axios.get(`/api/v1/items/${this.item.uuid}/feeds`);
        if (response.data.data) {
          this.feeds = response.data.data;
        }
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .table {
   td, tr {
     vertical-align: middle !important;
   }
  }
</style>
